import { siteInfoLang } from "commonAssets/js/constants";

/**
 * Sets the title of the webpage based on the current page and site information.
 *
 * @param {Array} sitePages - An array of page objects, each containing a PageName and PageTitle property.
 * @param {string} [domainSlug='home'] - The domainSlug of the current page, defaults to 'home'.
 */
export function siteTitle(sitePages, domainSlug = "home") {
    sitePages.forEach((page) => {
        if (domainSlug !== page.PageName) return;
        document.title = page.PageTitle + " - " + siteInfoLang.SiteTitle;
    });
}
